import { Component } from 'react'
import gsap from 'gsap'

class SectionIntro extends Component {
    componentDidMount(){
        var IntroIn = gsap.timeline();
       

        //3.1s
        IntroIn.add( gsap.from("#intro-wrap", {duration: 2.5, delay: .5, ease: "slow(0.2, 0.4, false)", opacity: 0}) );
       
    }
    render () {
        return (
            <div className="section-wrap" id="intro-wrap">
                <div id="intro-title">
                    <p>
                        <span id="intro-titletxt-2">WELCOME TO </span>
                        <span id="intro-titletxt-1">CTENA.</span>
                        <span id="intro-titletxt-3">(!)</span>
                    </p>
                </div>
                <div id="intro-subtitle">
                    <p>
                    Our Decentralized Application Dapp <b>CTENA Vault <a href="https://vault.ctena.finance/">XOOOX</a></b>
                    with the aim to solves clear (DeFi) user pain points for accessing the DeFi market!
                    </p>
                    <p></p>
                    <p>
                    The Ctena Token is a community driven, fair launched DeFi Token. Three simple functions
                    occur during each trade: Reflection, LP Acquisition, and Burn.
                    </p>
                </div>  
                <br></br>
                <div id="intro-title">
                    <p>
                        <span id="intro-titletxt-2">OUR TOKENS</span>
                    </p>
                </div>
                <div id="intro-subtitle">
                    <p>
                    CTENA:<br></br> Legacy Token with autoliquidity and burning features. Deflationary.
                    </p>
                    <br></br>
                    <p></p>
                   {/*  <p>
                    CBASE:<br></br> Algoritmic Based Stablecoin. Elastic Supply. (VERY VERY SOON!!)
                    </p>
                    <br></br>
                    <p>
                    xCBASE:<br></br> Utility Token for CBASE stablecoin .(VERY SOON!!!)
                    </p>
                    <br></br><p>
                    CRING: <br></br>Token Peg to Index fund compose by 70% BTC / 30% ETH. Deflationary.(SOON)
                    </p> */}
                </div>          
            </div>
			)
        }
    }
  

export default SectionIntro
